import { TouchableOpacity } from 'react-native'
import { styled } from '~/utils'

export const Trigger = styled(TouchableOpacity, () => {
  return {
    base: {},
  }
})
